import { Component, Input, OnInit } from '@angular/core';
import { PagedResponse } from '@edl-development/edl-common';
import { StateService, Transition } from '@uirouter/core';

@Component({
    selector: 'comply-pagination',
    templateUrl: './comply-pagination.component.html',
    styleUrls: ['./comply-pagination.component.scss']
})
export class ComplyPaginationComponent implements OnInit {
    @Input() pagedResponse?: PagedResponse<any>;
    @Input() pageSizes: number[] = [10, 25, 50];

    currentPage: number = 1;
    pageSize: number = 10;
    adjustedPageSize: number[] = [];

    constructor(
        private stateService: StateService,
        private transition: Transition
    ) { }

    ngOnInit(): void {
        const { page } = this.transition?.params<{ page: number }>?.() ?? {};
        this.currentPage = page ?? 1;
        this.pageSize = this.pagedResponse?.Limit || 10;
    }

    public changePageSize(limit: number): void {
        this.stateService.go('.', { page: 1, limit });
    }

    public onPageChange = (page: number) => {
        this.stateService.go('.', { page });
    }

    public get totalCount(): number {
        return this.pagedResponse?.TotalCount ?? 0;
    }

    public get displayStart(): number {
        if (this.totalCount === 0) return 0;

        return ((this.currentPage - 1) * this.pageSize) + 1;
    }

    public get displayEnd(): number {
        if (this.totalCount === 0) return 0;

        return Math.min(this.currentPage * this.pageSize, this.totalCount);
    }
}
